module.exports = __webpack_public_path__ + "static/melbourne-37ac303733f955406260632bf2e1dc52.jpg";